export default [
  {
    "x": 142.8378,
    "y": 44.4874,
    "angle": -2.1024689595818513,
    "lengthA": 16.177297056580098,
    "lengthB": 2.3879498375145642
  },
  {
    "x": 147.6258,
    "y": 42.6754,
    "angle": 1.5707963267948966,
    "lengthA": 2.519999999999996,
    "lengthB": 13.921717900000004
  },
  {
    "x": 161.2238,
    "y": 17.0664,
    "angle": 1.5707963267948966,
    "lengthA": 8.197999999999997,
    "lengthB": 9.386000000000003
  },
  {
    "x": 144.1588,
    "y": 0.0004,
    "angle": 0,
    "lengthA": 9.385999999999996,
    "lengthB": 9.522498000000013
  },
  {
    "x": 114.6508,
    "y": 0.0004,
    "angle": 0,
    "lengthA": 5.151427999999996,
    "lengthB": 9.38600000000001
  },
  {
    "x": 97.5858,
    "y": 17.0664,
    "angle": -1.5707963267948966,
    "lengthA": 9.386000000000003,
    "lengthB": 9.384999999999998
  },
  {
    "x": 114.6508,
    "y": 34.1314,
    "angle": 3.141592653589793,
    "lengthA": 9.38600000000001,
    "lengthB": 9.518
  }
]